import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { DeleteModal } from 'src/common/DeleteModal';
import { useTripRequestEmbedDestroyMutation } from 'src/common/external/bambi-api/bambiApi';
import { show } from 'src/common/primitives/Toast/toast.slice';
import { formatRTKQueryError } from 'src/common/util/formatRTKQueryError';

import { settingSlice } from '../setting.slice';

export function TripRequestEmbedDeleteModal() {
  const dispatch = useAppDispatch();
  const { isOpen, tripRequestEmbed } = useAppSelector(
    (state) => state.setting.tripRequestEmbedDeleteModal
  );

  const [
    deleteTripRequestEmbed,
    {
      isLoading: isDeletingTripRequestEmbed,
      error: deleteTripRequestEmbedError,
    },
  ] = useTripRequestEmbedDestroyMutation();

  return (
    <DeleteModal
      open={isOpen}
      setOpen={() =>
        dispatch(settingSlice.actions.closeTripRequestEmbedDeleteModal())
      }
      onCancel={() =>
        dispatch(settingSlice.actions.closeTripRequestEmbedDeleteModal())
      }
      onConfirm={async () => {
        if (tripRequestEmbed?.id) {
          try {
            await deleteTripRequestEmbed({
              id: tripRequestEmbed.id,
            }).unwrap();
            dispatch(
              show({
                title: `${tripRequestEmbed.label} deleted successfully`,
                type: 'success',
              })
            );
            dispatch(settingSlice.actions.closeTripRequestEmbedDeleteModal());
          } catch {
            dispatch(
              show({
                title: 'Error deleting trip request embed',
                description:
                  'There was an error deleting the trip request embed.',
                type: 'error',
              })
            );
          }
        }
      }}
      error={
        deleteTripRequestEmbedError
          ? formatRTKQueryError(deleteTripRequestEmbedError)
          : undefined
      }
      loading={isDeletingTripRequestEmbed}
      title={`Delete trip request embed: "${tripRequestEmbed?.label}"?`}
      description="Trip requests will no longer be received from this embed. This action cannot be undone."
    />
  );
}
